// state
import type { StateTree } from '@makemydeal/dr-dash-types';
import type { FeeOverride } from '@makemydeal/dr-platform-types';

// types
import type { FeeCategory } from '@makemydeal/dr-shared-types';

export const getFeesByCategory = (state: StateTree, categoryTitle: string): FeeCategory[] => {
    return state.payment.feesByCategory?.[categoryTitle.toLowerCase()] || [];
};

export const getFeesOverrides = (state: StateTree): FeeOverride[] => {
    return state.payment?.feesOverrides || [];
};
